import React                       from 'react';
import { KirokuCardDeletedScreen } from '../../../ui';
import FormatTimestamp             from '../CommonComponent/FormatTimestamp';
import { useTranslation }          from 'react-i18next';

export default function CustomerList({ customers }) {
    const { t } = useTranslation();

    return (<div className="pt-3">
        <div className={'bg-white'}>
            <KirokuCardDeletedScreen>
                {customers.map((customer, index) => (
                    <div key={index}>
                        <div className='pl-3 pt-3'>
                            <div className='header-card-del word-break'>{customer.name}</div>
                            <div className='title-card-del pt-10px'>{t('DeletedList.deletedAt')} : <FormatTimestamp
                                timestampUnix={customer.delete_at}/></div>
                            <div className='title-card-del pt-10px'>{t('DeletedList.createdAt')} : <FormatTimestamp
                                timestampUnix={customer.create_at}/></div>
                        </div>
                        <hr className='hr-table-mobile'/>
                    </div>
                ))}
            </KirokuCardDeletedScreen>
        </div>
    </div>);
}
